module.exports = __webpack_public_path__ + "static/media/mitsubishi-bumper_selected.600ea504.svg";